<script lang="ts">
	import { Button, Container, Icon, Modal, Text, toast } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { requestDeleteScene } from '../list-helpers';
	import type { IAlarmZone } from 'src/components/AlarmZones/AlarmWizard/alarm_object';
	import { scenes } from 'src/stores/lists/scenes';
	import { resetDrawer, resetDrawerClose } from 'src/helpers/drawer_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showDeleteAlarmModal = false;
	export let items: IAlarmZone[];
	export let alarm_name: string;
	export let alarm_id: string;

	const onCloseDeleteModal = () => {
		showDeleteAlarmModal = false;
	};

	const onDeleteAlarm = async () => {
		const res = await requestDeleteScene(alarm_id);
		if (items) {
			items = items.filter((alarm) => alarm._id !== alarm_id);
		}

		if (res.isok) {
			scenes.remove(alarm_id);
			if ($showNewLayout) {
				resetDrawerClose();
			} else {
				resetDrawer();
			}
		} else {
			return toast.open({
				type: 'danger',
				title:
					$format(`type_del_err_toast`, {
						values: { this_type: $format(`process_delete_alarm`) },
					}) || `Failed to delete alarm`,
			});
		}
		onCloseDeleteModal();
	};
</script>

<Modal
	on:close={onCloseDeleteModal}
	showModal={showDeleteAlarmModal}
	title={$format('prompt_title_delete_alarm', {
		default: 'Delete alarm?',
	})}
>
	<Container slot="content" padding="0">
		<div class="d-flex flex-direction-column align-items-center">
			<Icon size="xxl" icon="fa-light fa-trash" class="text-danger mb-xs" />
			<Text class="text-bold text-center mb-s" styleType="controls-large">
				{alarm_name}
			</Text>
			<Text class="width-full">
				{$format('on_delete_item_msg', {
					values: {
						device_name: alarm_name,
						type: $format('process_alarm', {
							default: 'alarm',
						}),
					},
					default: `Deleting ${$format('process_alarm', {
						default: 'alarm',
					}).toLowerCase()} ‘${alarm_name}’ will permanently remove it from your account.`,
				})}
			</Text>
		</div>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={(e) => onCloseDeleteModal()}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onDeleteAlarm}
			>{$format('button_delete_alarm', {
				default: 'Delete alarm',
			})}
		</Button>
	</div>
</Modal>
